import type { ComponentProps } from "react";

import { cn } from "./lib/cn";
import { Button } from "./ui/button";

export type SuggestionsProps = ComponentProps<"div">;
/** Wrapping, centered row of prompt suggestions, from the shadcn chatbot template empty state. */
export const Suggestions = ({ className, ...props }: SuggestionsProps) => (
  <div
    className={cn("flex flex-wrap justify-center gap-2", className)}
    data-slot="suggestions"
    {...props}
  />
);

export type SuggestionProps = Omit<ComponentProps<typeof Button>, "onClick"> & {
  suggestion: string;
  onSuggestionClick?: (suggestion: string) => void;
};
/** One clickable prompt suggestion chip that reports its prompt text when pressed. */
export const Suggestion = ({
  suggestion,
  onSuggestionClick,
  className,
  variant = "outline",
  size = "sm",
  children,
  ...props
}: SuggestionProps) => (
  <Button
    className={cn("rounded-full", className)}
    data-slot="suggestion"
    onClick={() => onSuggestionClick?.(suggestion)}
    size={size}
    type="button"
    variant={variant}
    {...props}
  >
    {children ?? suggestion}
  </Button>
);
